import { Injectable} from "@angular/core";
import {WindowRefService} from "./window.service";
declare var ga:Function;
@Injectable()
export class AnalyticsService {
    private ga:any;
    private _window: any;
    constructor(
        windowRef: WindowRefService,
    ){
        this._window = windowRef.nativeWindow;
        let config =  this._window.ApiConfig;
        if(!config.disableAnalytics) {
            let analyticsId = config.analytics_id || 'UA-37700219-8';
            ga('create', analyticsId, 'auto');
            ga('send', 'pageview');
            this.ga = ga;
        }
    }
    trackPageview(){
        if(this.ga) this.ga('send', 'pageview');
    }

    trackEvent(a,b,c){
        if(this.ga) this.ga('send', 'event', a,b,c);
    }
}